module.exports = __webpack_public_path__ + "img/tuijianjigou4.61020237.png";